import type { ClipboardService } from '@/domain/shared/ClipboardService'

export class BrowserClipboardService implements ClipboardService {
  async writeText(text: string): Promise<void> {
    if (!navigator.clipboard) {
      throw new Error('Clipboard API not supported in this browser context')
    }
    return navigator.clipboard.writeText(text)
  }
}
